import { formatAudienceReplyRatePct } from '@marketing-hub/shared';
import styles from '@/pages/ProjectsPage.module.css';

export function AudienceCampaignKpiPanel({
  enrollments,
  replies,
  bounces,
  mailsSent,
  replyRate,
  campaignsLinked,
}: {
  enrollments: number;
  replies: number;
  bounces: number;
  mailsSent: number;
  replyRate: number | null;
  campaignsLinked: number;
}) {
  if (campaignsLinked === 0 && enrollments === 0) {
    return (
      <section className={styles.card}>
        <h2>Campagne-resultaten</h2>
        <p className={styles.mutedSmall}>
          Nog geen campagnes gekoppeld aan deze doelgroep. Koppel een campagne in de wizard of tab
          Campagnes.
        </p>
      </section>
    );
  }

  return (
    <section className={styles.card}>
      <h2>Campagne-resultaten</h2>
      <p className={styles.mutedSmall}>
        Geaggregeerd over {campaignsLinked} campagne(s) met <code>audience_id</code>. Response rate
        = enrollments met reply-stop / totaal enrollments.
      </p>
      <ul className={styles.list}>
        <li>
          <strong>Response rate:</strong> {formatAudienceReplyRatePct(replyRate ?? undefined)}
        </li>
        <li>
          Enrollments: {enrollments} · Replies: {replies} · Bounces: {bounces}
        </li>
        <li>Verzonden mails: {mailsSent}</li>
      </ul>
    </section>
  );
}
